import { AsyncPipe, DatePipe } from '@angular/common';
  import { ChangeDetectionStrategy, Component, OnInit, input, inject } from '@angular/core';
import { AuthSevices } from '@fitness-force/api';
import type { GetPlanMasterByIdResponse, PlanBreakUpCalculationResponse, PlanMasterServices, SubscriptionById, UpgradePlanBreakUpResponse } from '@fitness-force/models';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { TranslateModule } from '@ngx-translate/core';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'upgrade-membership-info',
  templateUrl: './upgrade-membership-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DividerModule,
    SkeletonModule,
    StyleClassModule,
    CurrencyformatPipe,
    TranslateModule,
    AsyncPipe,
    DatePipe
]
})
export class UpgradeMembershipInfoComponent implements OnInit {
  authService = inject(AuthSevices);

  readonly planMaster = input<GetPlanMasterByIdResponse>({} as GetPlanMasterByIdResponse);
  readonly fromSubscription = input<SubscriptionById>({} as SubscriptionById);
  readonly showSkeleton$ = input(new BehaviorSubject<boolean>(true), { alias: "showSkeleton" });
  readonly subscriptionStartDate = input<Date>();
  readonly showInfo$ = input<boolean>(true, { alias: "showInfo" });
  readonly showCalculation$ = input<boolean>(true, { alias: "showCalculation" });
  readonly upgardePlanBreakUpResponse$ = input(new BehaviorSubject<PlanBreakUpCalculationResponse>({} as PlanBreakUpCalculationResponse), { alias: "upgardePlanBreakUpResponse" });// Observable<>; //UpgradePlanBreakUpResponse  = {} as UpgradePlanBreakUpResponse;

  UpgradeDate: Date = new Date();

  ngOnInit(): void {
    this.UpgradeDate= new Date();
  }

  allServiceNameHtml(oData: GetPlanMasterByIdResponse): string {
    let serviceCategoryName: string[] = [];
    let serviceCategory: any[] = [];
    oData.recurring_services.forEach((oService: PlanMasterServices) => {
      if (serviceCategoryName.indexOf(oService.name_primary_language) == -1) {
        serviceCategoryName.push(oService.name_primary_language);
        serviceCategory.push({
          name: oService.name_primary_language,
          isBaseMembership: oService.is_base_membership,
        });
      }
    });

    let str: string = `{{First}} {{Others}}`;

    let other: string = '';
    let first: string = '';
    for (let i = 0; i < serviceCategory.length; i++) {
      if (i == 0)
        first =
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round" > Base Membership </span>'
            : '');
      else
        other =
          other +
          '<br class="md:hidden"> + ' +
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round" > Base Membership </span>'
            : '');
    }

    return str.replace('{{First}}', first).replace('{{Others}}', other);
  }
  
}
